import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CanActivateViaAuthGuard } from './core/services/auth.guard';
import { VerificacionDocumentoComponent } from './docgest/_verificacion-documento/verificacion-documento.component';

const routes: Routes = [
  {
    path: 'index.html',
    component: VerificacionDocumentoComponent
  }, {
    path: '',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'recogidas',
    loadChildren: () => import('./recogidas/recogidas.module').then(m => m.RecogidasModule),
    canActivateChild: [CanActivateViaAuthGuard]
  }, {
    path: 'pedidos',
    loadChildren: () => import('./pedidos/pedidos.module').then(m => m.PedidosModule),
    canActivateChild: [CanActivateViaAuthGuard]
  }, {
    path: 'residuos',
    loadChildren: () => import('./da/da.module').then(m => m.DAModule),
    canActivateChild: [CanActivateViaAuthGuard]
  }, {
    path: 'documentos',
    loadChildren: () => import('./docclientes/docclientes.module').then(m => m.DocClientesModule),
    canActivateChild: [CanActivateViaAuthGuard]
  },{
    path: 'historicopedidos',
    loadChildren: () => import('./historicopedidos/historicopedidos.module').then(m => m.HistoricopedidosModule),
    canActivateChild: [CanActivateViaAuthGuard]
  },{
    path: 'rgestor',
    loadChildren: () => import('./pedgestor/pedgestor.module').then(m => m.PedgestorModule),
    canActivateChild: [CanActivateViaAuthGuard]
  },{
    path: 'cgest',
    loadChildren: () => import('./cantgest/cantgest.module').then(m => m.CantgestModule),
    canActivateChild: [CanActivateViaAuthGuard]
  },{
    path: 'sdocs',
    loadChildren: () => import('./subirdocs/subirdocs.module').then(m => m.SubirdocsModule),
    canActivateChild: [CanActivateViaAuthGuard]
  },{
    path: 'graficos',
    loadChildren: () => import('./graficos/graficos.module').then(m => m.GraficosModule),
    canActivateChild: [CanActivateViaAuthGuard]
  },{
    path: 'certificados',
    loadChildren: () => import('./certificados/certificados.module').then(m => m.CertificadosModule)
  },{
    path: 'externo',
    loadChildren: () => import('./hcpendientes/hcpendientes.module').then(m => m.HcpendientesModule),
    canActivateChild: [CanActivateViaAuthGuard]
  },{
    path: 'cage',
    loadChildren: () => import('./cantage/cantage.module').then(m => m.CantageModule),
    canActivateChild: [CanActivateViaAuthGuard]
  },{
    path: 'sdocsage',
    loadChildren: () => import('./subirdocsage/subirdocsage.module').then(m => m.SubirdocsAgeModule),
    canActivateChild: [CanActivateViaAuthGuard]
  },{
    path: 'finalizadas',
    loadChildren: () => import('./hcfinalizadas/hcfinalizadas.module').then(m => m.HcfinalizadasModule),
    canActivateChild: [CanActivateViaAuthGuard]
  },{
    path: 'docgest',
    loadChildren: () => import('./docgest/docgest.module').then(m => m.DocGestModule)
  },{
    path: 'incidencias',
    loadChildren: () => import('./incidencias/incidencias.module').then(m => m.IncidenciasModule),
    canActivateChild: [CanActivateViaAuthGuard]
  },
  // otherwise redirect to home
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
